module.exports = __webpack_public_path__ + "img/UK.d7a60b3.svg";